<template>
  <div class="gradient-div">
    <!-- 页面内容区域 -->
    <div class="content">
      <!-- 头部区域 - 統一容器 -->
      <div class="content-container">
        <section id="header" class="section" ref="header">
          <div class="container">
            <!-- 修改後的 decoration-container 使用 Grid 佈局 -->
            <div class="decoration-container">
              <!-- 圖片位置通過 Grid 定位 -->
              <img
                src="../assets/home/程序.png"
                alt="程序"
                class="decoration-img img-pos-1"
              />
              <img
                src="../assets/home/手册.png"
                alt="手册"
                class="decoration-img img-pos-2"
              />
              <img
                src="../assets/home/功能块.png"
                alt="功能块"
                class="decoration-img img-pos-3"
              />
              <img
                src="../assets/home/框架.png"
                alt="框架"
                class="decoration-img img-pos-4"
              />
              
              <!-- 標題在 Grid 的中間位置 -->
              <h3 class="section-title">构建精准适配体系 响应实战化场景需求</h3>
              <h2 class="section-title-download">一键下载！</h2>
            </div>

            <div class="section-content-solution">
              <el-button
                type="primary"
                plain
                round
                style="width: 160px; font-size: 20px"
                size="larger"
                @click="scrollToSection('solution')"
                class="headButton"
              >
                行业解决方案
              </el-button>
              <el-button
                type="primary"
                plain
                round
                style="width: 160px; font-size: 20px"
                size="larger"
                class="headButton"
                @click="scrollToSection('technology')"
              >
                核心技术
              </el-button>
              <el-button
                type="primary"
                plain
                round
                style="width: 160px; font-size: 20px"
                size="larger"
                class="headButton"
                @click="scrollToSection('sgm')"
              >
                SGM
              </el-button>
            </div>
          </div>
        </section>
      </div>

      <!-- 行业解决方案 - 統一容器 -->
      <div class="content-container">
        <section id="solution" class="section-solution" ref="solution">
          <div class="container-solution">
            <h2 class="section-title-solution">行业解决方案</h2>
             <div class="category-tabs-container">
                <!-- 左箭頭 -->
                <div 
                  v-if="showScrollArrows"
                  class="scroll-arrow left-arrow"
                  :class="{ disabled: !canScrollLeft }"
                  @click="scrollLeft"
                >
                  <i class="el-icon-arrow-left"></i>
                </div>
                
                <!-- 滾動區域 -->
                <div 
                  class="category-tabs"
                  ref="tabsContainer"
                  @scroll="handleScroll"
                >
                  <el-button
                    v-for="category in categories"
                    :key="category.id"
                    :class="[
                      'category-btn',
                      { active: activeCategory === category.id },
                    ]"
                    @click="selectCategory(category.id)"
                  >
                    {{ category.name }}
                  </el-button>
                </div>
                
                <!-- 右箭頭 -->
                <div 
                  v-if="showScrollArrows"
                  class="scroll-arrow right-arrow"
                  :class="{ disabled: !canScrollRight }"
                  @click="scrollRight"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>

            <!-- 在模板中，當沒有項目時顯示佔位容器 -->
            <div v-if="filteredDevices.length === 0" class="no-data-placeholder">
              <div class="empty-grid-container">
                <div class="empty-card-placeholder" v-for="n in 3" :key="'placeholder-' + n">
                  <div class="placeholder-image"></div>
                  <div class="placeholder-content">
                    <div class="placeholder-title"></div>
                    <div class="placeholder-text"></div>
                    <div class="placeholder-text-short"></div>
                  </div>
                </div>
              </div>
              <div class="no-data-message">
                <i class="el-icon-folder-opened"></i>
                <p>該分類暫無解決方案</p>
              </div>
            </div>

            <div class="devices-grid">
              <div
                class="device-card"
                v-for="(device, index) in filteredDevices"
                :key="device.id"
                @click="navigateTo('solution', device)"
                :class="{ 'active-hover': index === activeButton }"
              >
                <el-card class="product-card" shadow="hover">
                  <div class="card-image">
                    <img 
                      :src="getImageUrlFromPath(device.imagePath)" 
                      :alt="device.name"
                      @error="handleImageError"
                    />
                  </div>
                  <div class="card-content">
                    <h4>{{ device.name }}</h4>
                    <p class="card-description">{{ device.description }}</p>
                  </div>

                  <div class="card-footer">
                    <div class="color-bar"></div>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- 核心技术 - 統一容器 -->
      <div class="content-container">
        <section id="technology" class="section-technology" ref="technology">
          <div class="container">
            <h2 class="section-title-solution">核心技术</h2>
            <div class="devices-grid">
              <div
                class="device-card-technology"
                v-for="technology in filteredCoreTechnology"
                :key="technology.id"
                @click="navigateTo('technology', technology)"
              >
                <div class="device-image">
                  <img 
                    :src="getImageUrlFromPath(technology.imagePath)" 
                    :alt="technology.name"
                    @error="handleImageError"
                  />
                </div>
                <div class="device-content-technology">             
                  <p class="technology-name">{{ technology.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- SGM - 統一容器 -->
      <div class="content-container">
        <section id="sgm" class="section-SGM" ref="sgm">
          <div class="container">
            <h2 class="section-title-solution">SGM</h2>
            <div class="section-content-sgm">
              <div class="sgm-image">
                <img src="../assets/SGM/SGMpic.jpg" 
                    @click="navigateTo('sgmSolution')"
                    style="cursor: pointer;"
                    alt="SGM Solution"/>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Login, getByEmail, getUserById } from "@/api/user";
import { GetIndustrys,GetIndustrySolutions} from "@/api/industry";
import { AuthService } from "@/utils/auth";
import { getImageUrl, getImageUrls } from '@/utils/imageUtils'
import { GetCoreTechnologes } from "@/api/CoreTechnology";

export default {
  name: "HomeView",
  data() {
    return {
      activeIndex: "home", // 当前激活的菜单项
      mobileMenuVisible: false, // 移动端菜单可见性
      currentLanguage: "zh-Hans", // 当前语言
      authUrl: "",
      authService: new AuthService(),
      activeButton: -1,
      // 联系表单
      contactForm: {
        name: "",
        email: "",
        message: "",
      },
      // 表单验证规则
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        message: [
          { required: true, message: "请输入留言内容", trigger: "blur" },
        ],
      },
      activeCategory: -1, // 默认选中第一个分类（全部）
      categories: [
        // { id: -1, name: "全部" },
        // { id: 0, name: "绕线" },
        // { id: 1, name: "流体" },
        // { id: 2, name: "橡塑" },
        // { id: 3, name: "多线切" },
        // { id: 4, name: "包装" },
        // { id: 5, name: "机器人" },
      ],

      activeTab: "全部",
      tableData:[],
      industrySolutions: [], // 新增：存儲所有解決方案
      filteredDevices: [],
      filteredCoreTechnology: [],
      // 新增圖片 URL 映射
      imageUrlMap: {},
      canScrollLeft: false,
      canScrollRight: false,
      showScrollArrows: false,
    };
  },
  watch: {},
  mounted(){
    this.$nextTick(() => {
    this.checkScroll();
    
    // 強制在 1 秒後再檢查一次
    setTimeout(() => {
      this.checkScroll();
      // 如果需要，強制顯示箭頭
      this.showScrollArrows = true;
    }, 1000);
  });
  },
  activated() {
    if (this.$route.hash) {
      const element = document.querySelector(this.$route.hash);
      if (element) {
        element.scrollIntoView({ behavior: "auto" });
      }
    };
    this.getIndustry();
    this.getIndustrySolutions();
    this.getcoreTechnologes();
  },

  beforeDestroy() {
    // 清理組件級的圖片緩存
    Object.keys(this.imageUrlMap).forEach(key => {
      if (this.imageUrlMap[key] && this.imageUrlMap[key].startsWith('blob:')) {
        revokeObjectURL(this.imageUrlMap[key]);
      }
    });
    this.imageUrlMap = {};
    window.removeEventListener('resize', this.checkScroll);
  },
  methods: {
    getcoreTechnologes(){
      GetCoreTechnologes('').then((res) => {
        if (res.status === 200) {
          this.filteredCoreTechnology = res.data.data.items;
          // 从0开始生成顺序数字作为id
          const idNameArray = res.data.data.items.map((item, index) => ({
            id: index,  // 从0开始
            name: item.name,
            description: item.description,
            category:item.name,
            imagePath:item.imagePath,
            coretechnologyId: item.id,
          }));  
           this.filteredCoreTechnology = [...idNameArray];        
        }      
      });
    },
    // 獲取圖片 URL（優先從緩存取）
    getImageUrlFromPath(imagePath) {
      if (!imagePath) return '';
      
      if(imagePath.includes('http')){
         return imagePath;
      }
      return ''; // 或者返回一個佔位圖
    },
    
    // 加載並緩存單個圖片
    async loadImageAndCache(imagePath) {
      if (!imagePath) return;
      
      try {
        const url = imagePath;//await getImageUrl(imagePath);
        if (url) {
          // 使用 Vue.set 確保響應式更新
          this.$set(this.imageUrlMap, imagePath, url);
        }
      } catch (error) {
        console.error('加載圖片失敗:', error);
      }
    },
    
    // 圖片加載失敗處理
    handleImageError(event) {
      const img = event.target;
      const deviceId = img.getAttribute('data-device-id');
      
      // 可以設置默認圖片
      //img.src = require('@/assets/default-image.jpg');
      img.onerror = null; // 防止循環錯誤
    },

    getIndustry() {
      GetIndustrys('').then((res) => {        
        if (res.status === 200) {
          // 创建"全部"选项
          const allOption = { id: -1, name: "全部" };
          
          // 从1开始生成顺序数字作为id
          const idNameArray = res.data.data.items.map((item, index) => ({
            id: index,  // 从0开始
            name: item.name
          }));
          
          // 将"全部"选项放在数组开头
          this.categories = [allOption, ...idNameArray];           
        }
      })      
    },
    // 获取行业方案列表
    getIndustrySolutions()
    {
      GetIndustrySolutions('').then((res) =>{
        if (res.status === 200) {
          const idNameArray = res.data.data.items.reverse().map((item, index) => ({
            id: index,  // 从0开始            
            name: item.name,
            description:item.description,
            spIntroduction: item.spIntroduction,
            posterPath: item.posterPath,
            imagePath: item.imagePath,
            packagePath: item.packagePath,
            viewCount: item.viewCount,
            downloadCount:item.downloadCount,
            likesCount: item.likesCount,
            score: item.score,
            createDate: item.createDate,
            lastUpdateDate: item.lastUpdateDate,
            createBy:item.createBy,
            downloadItemId : item.id,
            category: item.industryName, // 確保 API 返回中包含分類信息
          }));
          // 保存所有解決方案
          this.industrySolutions = [...idNameArray];

          // 根據當前選中的分類初始化 filteredDevices
          if (this.activeCategory === -1) {
            this.filteredDevices = [...this.industrySolutions];
          } else {
            const selectedCategoryName = this.getCategoryName(this.activeCategory);
            this.filteredDevices = this.industrySolutions.filter(solution => 
              solution.category === selectedCategoryName
            );
          }     
          //console.log(this.filteredDevices);
          // 批量獲取圖片 URL
          this.loadImagesForDevices(this.filteredDevices); 

        }
        });
    }, 
    // 新增方法：批量加載圖片
    async loadImagesForDevices(devices) {
      const imagePaths = devices
        .map(device => device.imagePath)
        .filter(path => path); // 過濾掉空路徑
      
      if (imagePaths.length > 0) {
        try {
          const urlMap = imagePaths;//await getImageUrls(imagePaths);
          this.imageUrlMap = { ...this.imageUrlMap, ...urlMap };
          
        } catch (error) {
          console.error('加載圖片失敗:', error);
        }
      }
    },   
    
    goToSGMSolution() {
      // 使用路由跳转到 SGMSolution 页面
      this.$router.push('/SGMSolution');
      
      // 或者如果使用路由名称：
      // this.$router.push({ name: 'SGMSolution' });
      
      // 或者如果使用路径别名：
      // this.$router.push('/sgm-solution');
    },

    // 处理菜单选择
    handleMenuSelect(index, indexPath) {
      this.activeIndex = index;
      console.log("菜单选择:", index, indexPath);
    },

    // 处理移动端菜单选择
    handleMobileMenuSelect(index, indexPath) {
      console.log("处理移动端菜单选择:");
      this.handleMenuSelect(index, indexPath);
      this.mobileMenuVisible = false; // 选择后关闭移动菜单
    },

    // 导航到指定路径
    navigateTo(path, device) {
      //console.log(path, device);
      // 如果是外部链接，新窗口打开
      if (path.includes("http")) {
        window.open(path, "_blank");
      } 
      else if (path == "solution") {
        // 使用Vue Router进行导航
        this.$router
          .push({
            name: path,
            params: {            
              id: device.id,
              deviceInfo: device,
              otherInfo: this.filteredDevices.filter(
                (item) => item.id != device.id
              ),
            },
          })
          .catch(() => {});
      }
      else if (path == "technology"){
        // 使用Vue Router进行导航，此處為轉換到核心技術
        this.$router
          .push({
            name: path,
            params: {       
              id: device.id,
              technologyInfo: device,
              otherInfo: this.filteredCoreTechnology.filter(
                (item) => item.id != device.id
              ),
            },
          })
          .catch(() => {});
      }
      else if (path == "sgmSolution") {
        this.$router.push({ 
          name: "SGMSolution"  // 使用路由名稱而不是路徑
        });
      }
      //console.log(this.$route.params.deviceInfo);
    },

    // 处理语言切换
    handleLanguageChange(lang) {
      this.currentLanguage = lang;
      // 触发语言切换逻辑
      this.$router.push(`/Home/ChangeLanguage?lang=${lang}`);
      // 可以在这里添加语言包切换逻辑
      this.$i18n.locale = lang;
    },

    showDeviceDetail(device) {},
    // 滚动到指定区域
    scrollToSection(sectionId) {
      const element = this.$refs[sectionId];
      const elementTop =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offset = 60; // 顶部固定栏为60

      if (element) {
        window.scrollTo({
          top: elementTop - offset,
          behavior: "smooth",
        });
      }
    },
    // 提交表单
    submitForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.$message.success("表单提交成功！");
          this.resetForm();
        } else {
          this.$message.error("请填写正确的表单信息");
          return false;
        }
      });
    },
    // 重置表单
    resetForm() {
      this.$refs.contactForm.resetFields();
    },

    selectCategory(categoryId) {
      this.activeCategory = categoryId; 
      this.activeButton = categoryId;

      // 根據選中的分類過濾解決方案
      if (categoryId === -1) {
        // 顯示全部
        this.filteredDevices = [...this.industrySolutions];
      } else {
        const selectedCategoryName = this.getCategoryName(categoryId);
        //console.log(selectedCategoryName);
        // 過濾出屬於該分類的解決方案
        this.filteredDevices = this.industrySolutions.filter(solution => 
          solution.category  === selectedCategoryName
        );
      }

      // 这里可以添加分类切换的业务逻辑
      //console.log("选中分类:", this.getCategoryName(categoryId));
    },
    getCategoryName(categoryId) {
      const category = this.categories.find((item) => item.id === categoryId);
      return category ? category.name : "";
    },
    handleSearch() {
      console.log("查找方法");
    },
    handleTabClick(tab) {
      this.activeTab = tab.name;
    },
    getImageUrl(imageName) {
      // 假设图片名存储在 device.image 中
      return require(`@/assets/${imageName}`);
    },

    
    login() {
      //  getByEmail("lola.du@deltaww.com").then((res) => {
    
      //  })

      const authService = new AuthService();
      authService.login();
    },

    test() {
      const userInfo = {
        userid: "lola.du",
        password: "7BBD73250516F069",
      };
      Login(userInfo).then((res) => {
        console.log("res", res);
      });
    },
    checkScroll() {
      const container = this.$refs.tabsContainer;
      if (!container) return;
      
      this.canScrollLeft = container.scrollLeft > 0;
      this.canScrollRight = 
        container.scrollLeft + container.clientWidth < container.scrollWidth;
      
      // 檢查是否需要顯示箭頭
      this.showScrollArrows = container.scrollWidth > container.clientWidth;
    },
    
    handleScroll() {
      this.checkScroll();
    },
    
    scrollLeft() {
      if (!this.canScrollLeft) return;
      const container = this.$refs.tabsContainer;
      container.scrollLeft -= 200; // 每次滾動 200px
    },
    
    scrollRight() {
      if (!this.canScrollRight) return;
      const container = this.$refs.tabsContainer;
      container.scrollLeft += 200; // 每次滾動 200px
    }
  
  },  
};
</script>

<style scoped>
/* 統一容器樣式 - 與其他頁面保持一致 */
.content-container {
  max-width: 1200px; /* 與其他頁面保持一致的最大寬度 */
  margin: 0 auto;     /* 水平居中 */
  padding: 0 20px;    /* 統一的左右邊距 */
  width: 100%;        /* 佔滿父容器 */
  box-sizing: border-box; /* 確保padding不影響總寬度 */
}

/* 主容器 */
.gradient-div {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 內容區域 */
.content {
  margin-top: 0px;
  width: 100%;
}

/* 區段共通樣式 */
.section {
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 0px solid #ebeef5;
  position: relative;
  width: 100%; /* 確保佔滿容器 */
}
.section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw; /* 使用視口寬度 */
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(256, 256, 256) 55%,
    rgb(146, 208, 249) 100%
  );
  z-index: 0; /* 確保在內容後面 */
}

.section-solution {
  min-height: 1020px; /* 最小高度 */
  height: auto; /* 自動高度 */
  padding: 60px 0; /* 上下內邊距 */
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 從頂部對齊 */
  align-items: center; /* 水平居中 */
  border-bottom: 1px solid #ebeef5;
  /* background: linear-gradient(
    to bottom,
    rgba(256, 256, 256) 70%,
    rgb(210, 237, 253) 100%
  ); */
  position: relative; /* 新增：建立相對定位上下文 */
  width: 100%; /* 確保佔滿容器 */
  background: transparent; 
  z-index: 1; 
}
.section-solution::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%; /* 從中間開始 */  
  transform: translateX(-50%);
  width: 100vw; /* 使用視口寬度，超出 .content-container */
  height: 100%; /* 和父元素一樣高 */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255) 70%, /* 修正：255 不是 256 */
    rgb(210, 237, 253) 100%
  );
  z-index: 0; /* 背景在最底層 */
}

.section-technology {
  min-height: 500px; /* 固定最小高度 */
  padding: 60px 0; /* 使用 padding 控制間距 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #ebeef5;
  /* background: linear-gradient(
    to bottom,
    rgba(256, 256, 256) 70%,
    rgb(210, 237, 253) 100%
  ); */
  width: 100%; /* 確保佔滿容器 */
  position: relative;
  z-index: 1;
}
.section-technology::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw; /* 全視窗寬度 */
  height: 100%; /* 跟隨父元素高度 */
  min-height: 500px; /* 確保最小高度 */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255) 70%, /* 修正：255, 255, 255 */
    rgb(210, 237, 253) 100%
  );
  z-index: 0; /* 背景在底層 */
  pointer-events: none; /* 不干擾點擊事件 */
}

.section-SGM {
  min-height: 540px; /* 固定最小高度 */
  padding: 60px 0; /* 使用 padding 替代固定高度 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #ebeef5;
  /* background: linear-gradient(
    to bottom,
    rgba(256, 256, 256) 70%,
    rgb(210, 237, 253) 100%
  ); */
  position: relative;
  overflow: visible; /* 确保内容不会被隐藏 */
  z-index: 1; /* 确保section层级 */
  width: 100%; /* 確保佔滿容器 */
}

.section-SGM::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw; /* 全視窗寬度 */
  height: 100%; /* 跟隨父元素高度 */
  min-height: 540px; /* 確保最小高度 */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255) 70%, /* 修正：255, 255, 255 */
    rgb(210, 237, 253) 100%
  );
  z-index: 0; /* 背景在底層 */
  pointer-events: none; /* 不干擾點擊事件 */
}

/* 容器內部 */
.container, .container-solution {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0; /* 移除內部 padding，由容器控制 */
}

.container-solution {
  justify-content: flex-start; /* 從頂部開始排列 */
  min-height: 10px; /* 確保最小高度 */
  padding-top: 20px; /* 增加頂部間距 */
}
.section-title-solution {
  font-size: 35px;
  margin-bottom: 40px;
  color: black;
  text-align: center;
  position: relative; /* 添加相对定位 */
  z-index: 10; /* 提高层级 */
  display: block;
  width: 100%; /* 確保佔滿容器 */
  clear: both; /* 清除可能的浮动 */
}
/* 修改：Grid 佈局的裝飾容器 */
.decoration-container {
  display: grid;
  grid-template-columns: 1fr auto 1fr;  /* 三列：左 | 中(標題) | 右 */
  grid-template-rows: auto auto;        /* 兩行：標題行 | 下載標題行 */
  width: 100%;
  max-width: 1200px;
  margin: 20px auto 40px;
  position: relative;
  align-items: center;
  justify-items: center;
  gap: 10px 0; /* 行間距 10px，列間距 0 */
}

/* 裝飾圖片 */
.decoration-img {
  width: 60px;
  height: 60px;
  opacity: 0.7;
  pointer-events: none;
  animation: float 3s ease-in-out infinite alternate;
  z-index: 1;
}

/* 圖片位置 - 使用 Grid 定位 */
.img-pos-1 {
  grid-column: 1;  /* 第一列 */
  grid-row: 1;     /* 第一行 */
  justify-self: end;  /* 在列內靠右對齊 */
  margin-right: 50px;
  animation: float 3s ease-in-out infinite alternate;
}

.img-pos-2 {
  grid-column: 3;  /* 第三列 */
  grid-row: 1;     /* 第一行 */
  justify-self: start; /* 在列內靠左對齊 */
  margin-left: 50px;
  animation: float 3s ease-in-out infinite alternate;
}

.img-pos-3 {
  grid-column: 1;  /* 第一列 */
  grid-row: 2;     /* 第二行 */
  justify-self: end; /* 在列內靠右對齊 */
  margin-right: 120px;
  margin-top: 30px; /* 增加頂部間距，形成上下錯位 */
  animation: float 3s ease-in-out infinite alternate;
}

.img-pos-4 {
  grid-column: 3;  /* 第三列 */
  grid-row: 2;     /* 第二行 */
  justify-self: start; /* 在列內靠左對齊 */
  margin-left: 120px;
  margin-top: 30px; /* 增加頂部間距，形成上下錯位 */
  animation: float 3s ease-in-out infinite alternate;
}

/* 標題樣式 - 放在 Grid 中間 */
.section-title {
  font-size: 42px;
  margin-bottom: 30px; /* 減少下邊距，通過 gap 控制間距 */
  color: #0087c8;
  margin-top: 55px;
  text-align: center;
  width: 100%; /* 確保佔滿容器 */
  grid-column: 2;  /* 第二列（中間） */
  grid-row: 1;     /* 第一行 */
  align-self: end; /* 在行內底部對齊 */
}

.section-title-download {
  font-size: 56px;
  margin-bottom: 20px; /* 減少下邊距，按鈕會單獨處理 */
  color: #0087c8;
  margin-top: 0; /* 移除頂部邊距，通過 gap 控制 */
  text-align: center;
  width: 100%; /* 確保佔滿容器 */
  grid-column: 2;  /* 第二列（中間） */
  grid-row: 2;     /* 第二行 */
  align-self: start; /* 在行內頂部對齊 */
}

/* 按鈕區域 - 在 Grid 之外 */
.section-content-solution {
  font-size: 18px ;
  line-height: 1.8;
  margin-bottom: 50px;
  flex-wrap: nowrap;
  display: flex;
  gap: 80px;
  justify-content: center;
  width: 100%; /* 確保佔滿容器 */
  position: relative; /* 確保在圖片之上 */
  z-index: 2; /* 確保在圖片之上 */
  margin-top: 10px; /* 與上方的裝飾容器間距 */
}

/* 浮動動畫 */
@keyframes float {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-30px);
  }
}

/* 分類標籤容器 */
.category-tabs-container {
  position: relative;
  display: flex;
  align-items: center;
  background: linear-gradient(
    to right,
    rgb(22, 212, 228) 30%,
    rgba(96, 172, 251) 50%,
    rgb(24, 210, 229) 100%
  );
  padding: 10px 40px; /* 為箭頭留空間 */
  border: 2px solid #f1f2f3 !important;
  border-radius: 40px !important;
  width: 100%;
  margin: 0 auto 40px;
  box-sizing: border-box;
}

.category-tabs {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 6px;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex: 1;
  height: 50px;
  align-items: center;
}

.category-tabs::-webkit-scrollbar {
  display: none;
}

.category-tabs .el-button {
  flex: 0 0 auto;
  min-width: fit-content;
  padding: 8px 20px;
  white-space: nowrap;
}

/* 滾動箭頭 */
.scroll-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.scroll-arrow:hover {
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.scroll-arrow.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
}

/* 分類按鈕 */
.category-btn {
  border: 2px solid transparent !important;
  background-color: transparent !important;
  color: white !important;
  font-weight: bolder;
  padding: 8px 20px !important;
  font-size: 24px;
  transition: all 0.3s ease;
  min-width: 120px;
  white-space: nowrap; /* 防止文字換行 */
}

.category-btn.active {
  border: 2px solid #0087c8 !important; /* 只在选中时显示边框 */
  border-radius: 20px !important; /* 圆角 */
  background-color: #ecf5ff !important;
  color: #0087c8 !important;
  font-weight: bold !important;
}

.category-btn:hover {
  border: 2px solid #c6e2ff !important;
  border-radius: 20px !important; /* 圆角 */
  background-color: #f5f9ff !important;
  color: #0087c8 !important;
}

/* 設備網格 */
.devices-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 350px; /* 固定行高 */
  width: 100%; /* 改為100%，由容器控制寬度 */
  margin: 30px auto 50px; /* 上下邊距 */
  gap: 20px;
  min-height: 500px; /* 確保最小高度 */
  z-index: 1; 
}

/* 設備卡片 */
.device-card-technology {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  cursor: pointer;
  height: 100%; /* 確保佔滿網格單元 */
}

.device-card-technology:hover {
  transform: translateY(-5px);
}

.device-card {
  cursor: pointer;
  transition: all 0.3s;
  height: 100%; /* 確保佔滿網格單元 */
}

.device-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.device-card.active-hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* 設備圖片 */
.device-image {
  height: 230px;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 16px;
  width: 100%; /* 确保容器宽度自适应 */
  max-width: 100%; /* 防止容器溢出 */
}

.device-image img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持图片比例，不裁剪 */
}

/* SGM圖片 */
.sgm-image {
  height: auto; /* 修改：改为自适应高度 */
  min-height: 330px; /* 保留最小高度 */
  background-color: #ffffff; /* 保持背景色 bfccdf*/
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7f8ca5;
  font-size: 16px;
  width: 100%; /* 改為100%，由容器控制寬度 */
  max-width: 1000px; /* 限制最大寬度 */
  margin: 0 auto; /* 水平居中 */
  position: relative; /* 添加相对定位 */
  z-index: 1; /* 设置层级低于标题 */
  margin-top: 0; /* 确保顶部没有负边距 */
  padding-top: 0; /* 确保没有内边距问题 */
}

.sgm-image img {
  width: 100%;
  height: auto;
  max-height: 380px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.sgm-image img:hover {
  transform: scale(1.02);
}

/* 設備內容 */
.device-content-technology {
  padding: 15px 10px;
  text-align: center;
}

.technology-name {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

/* 產品卡片 */
.product-card {
  flex: 1;
  transition: all 0.3s ease;
  border-radius: 6px;
  overflow: hidden;
  background-color: #ffffff; /* 与页面背景相同的白色 */
  border: none; /* 无边框 */
  height: 100%; /* 確保佔滿父容器 */
  display: flex;
  flex-direction: column;
}

.product-card:hover {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

.product-card:hover .color-bar {
  transform: scaleX(1);
}

/* 卡片圖片 */
.card-image {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #e3f4ff; /* 浅灰色背景，与图片中的设备区域一致 */
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.5s ease;
}

.product-card:hover .card-image img {
  transform: scale(1.05);
}

/* 卡片內容 */
.card-content {
  padding: 10px;
  text-align: center;
  flex-grow: 1; /* 佔滿剩餘空間 */
  display: flex;
  flex-direction: column;
}

.card-content h4 {
  font-size: 16px;
  margin-bottom: 3px;
  margin-top: 8px;
  font-weight: 600;
  color: #303133;
}

.card-description {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 5px;
  flex-grow: 1; /* 描述文字佔滿可用空間 */
}

/* 卡片頁腳 */
.card-footer {
  position: relative;
  height: 6px;
  overflow: hidden;
  margin-top: auto; /* 推到卡片底部 */
}

.color-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background: linear-gradient(90deg, #409eff 50%, #67c23a 50%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

/* 空狀態樣式 */
.no-data-placeholder {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px 0; /* 垂直間距 */
  min-height: 300px; /* 確保有足夠的高度 */
  z-index: 1;
}

.no-data-message {
  text-align: center;
  color: #909399;
  font-size: 18px;
  width: 100%; /* 確保佔滿容器 */
}

.no-data-message i {
  font-size: 48px;
  margin-bottom: 20px;
  color: #c0c4cc;
}

.no-data-message p {
  font-size: 16px;
  margin: 0;
}

/* 頁首按鈕 */
.headButton {
  background: none !important;
  color: black !important;
  border: 1px solid #757ef2 !important;
  white-space: nowrap !important;
  width: 160px !important;
  font-size: 20px !important;
}

.headButton:hover {
  background: linear-gradient(
    to right,
    rgba(134, 104, 244) 25%,
    rgb(29, 205, 228) 100%
  ) !important;
  color: white !important;
}

/* 響應式設計 - 新增 Grid 佈局的響應式 */
@media (max-width: 1200px) {
  .decoration-container {
    max-width: 1000px;
  }
  
  .section-title {
    font-size: 36px;
  }
  
  .section-title-download {
    font-size: 48px;
  }
  
  .decoration-img {
    width: 50px;
    height: 50px;
  }
  
  .img-pos-1,
  .img-pos-3 {
    margin-right: 15px;
  }
  
  .img-pos-2,
  .img-pos-4 {
    margin-left: 15px;
  }
  
  .img-pos-3,
  .img-pos-4 {
    margin-top: 20px;
  }
}

@media (max-width: 992px) {
  .content-container {
    padding: 0 15px; /* 中等屏幕減少邊距 */
  }
  
  .devices-grid {
    grid-template-columns: repeat(2, 1fr); /* 平板設備顯示2列 */
    width: 100%; /* 確保佔滿容器 */
  }
  
  .section-title {
    font-size: 32px;
    margin-top: 40px;
  }
  
  .section-title-download {
    font-size: 40px;
  }
  
  .decoration-img {
    width: 45px;
    height: 45px;
  }
  
  .img-pos-1,
  .img-pos-3 {
    margin-right: 10px;
  }
  
  .img-pos-2,
  .img-pos-4 {
    margin-left: 10px;
  }
  
  .img-pos-3,
  .img-pos-4 {
    margin-top: 15px;
  }
  
  .section-content-solution {
    flex-direction: column;
    gap: 20px;
  }
  
  .section-content-solution .headButton {
    width: 140px;
    font-size: 18px;
  }
  
  .category-btn {
    font-size: 20px;
    padding: 8px 20px !important;
    min-width: 100px;
  }
}

@media (max-width: 768px) {
  .decoration-container {
    grid-template-columns: 1fr; /* 單列佈局 */
    grid-template-rows: auto auto auto auto auto auto; /* 6行：標題1、標題2、圖片1-4 */
    gap: 20px 0;
  }
  
  .section-title {
    font-size: 28px;
    margin-top: 30px;
    grid-column: 1;
    grid-row: 1;
  }
  
  .section-title-download {
    font-size: 36px;
    grid-column: 1;
    grid-row: 2;
  }
  
  .decoration-img {
    width: 40px;
    height: 40px;
  }
  
  /* 移動端圖片排列 */
  .img-pos-1 {
    grid-column: 1;
    grid-row: 3;
    justify-self: center;
    margin-right: 0;
  }
  
  .img-pos-2 {
    grid-column: 1;
    grid-row: 4;
    justify-self: center;
    margin-left: 0;
  }
  
  .img-pos-3 {
    grid-column: 1;
    grid-row: 5;
    justify-self: center;
    margin-right: 0;
    margin-top: 0;
  }
  
  .img-pos-4 {
    grid-column: 1;
    grid-row: 6;
    justify-self: center;
    margin-left: 0;
    margin-top: 0;
  }
  
  .section-content-solution {
    flex-direction: column;
    gap: 10px;
  }
  
  .section-content-solution .headButton {
    width: 120px;
    font-size: 16px;
  }
  
  .category-btn {
    font-size: 18px;
    padding: 6px 16px !important;
    min-width: 90px;
  }
  
  .section-solution,
  .section-technology,
  .section-SGM {
    min-height: auto; /* 移動設備取消固定最小高度 */
    padding: 40px 0;
  }
}

@media (max-width: 576px) {
  .content-container {
    padding: 0 8px; /* 最小屏幕最小邊距 */
  }
  
  .devices-grid {
    grid-template-columns: repeat(1, 1fr);
    width: 100%; /* 確保佔滿容器 */
  }
  
  .section-title {
    font-size: 24px;
    margin-top: 20px;
  }
  
  .section-title-download {
    font-size: 30px;
  }
  
  .decoration-img {
    width: 35px;
    height: 35px;
  }
  
  .section-content-solution {
    flex-direction: column;
    gap: 10px;
  }
  
  .section-content-solution .headButton {
    width: 100px;
    font-size: 14px;
  }
  
  .category-tabs {
    flex-wrap: wrap;
    height: auto;
  }
  
  .category-btn {
    flex: 0 0 calc(50% - 10px);
    margin: 5px;
    font-size: 16px;
    min-width: auto;
  }
  
  .section {
    height: 300px;
  }
}
</style>